namespace $ { $mol_style_attach( "mol/button/minor/minor.view.css",
 "[mol_button_minor] {\n\tcolor: var(--mol_theme_control);\n}\n"
) }